import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  useEffect,
} from 'react';
import _ from 'lodash';
import {
  Button,
  Input,
  Dialog,
  SelectTree,
  OverlayTrigger,
  PopOver,
  Loading,
  Switch,
} from '@tencent/spaui';
import moment from 'moment';
import jrQrcode from 'jr-qrcode';
import { ListView } from '@tencent/ptp-fe-common';

import { RPCFactory } from '../../../utils/RequestUtil';
import useCustomColumn from '../../hooks/useCustomFilter';
import { Tags } from '../../../consts/Tags';
import { LeadsDataFilterShortcut as DATE_SHORTCUTS } from '../../../consts/Common';
import { SelectionItemComponent, ValueAreaComponent } from './ownerPicker';
import { CorpSelector } from '../qw/corpSelector';

const CUSTOMER_DATA_REFRESH_DELAY = 1000;

const CUSTOMER_ADD_WAY_MAP = {
  0: '未知来源',
  1: '扫描二维码',
  2: '搜索手机号',
  3: '名片分享',
  4: '群聊',
  5: '手机通讯录',
  6: '微信联系人',
  7: '来自微信的添加好友申请',
  8: '安装第三方应用时自动添加的客服人员',
  9: '搜索邮箱',
  201: '内部成员共享',
  202: '管理员/负责人分配',
};

const CUSTOMER_DELETE_STATUS = {
  0: '正常',
  1: '客服删除',
  2: '客户删除',
};

const GENDER_MAP = {
  0: '未知',
  1: '男',
  2: '女',
};

const REPEAT_MAP = {
  0: '否',
  1: '是',
};

// const FOLLOW_STATUS_MAP = {
//   1: '待跟进',
//   2: '获得联系方式',
//   3: '潜在意向',
//   4: '待下单',
//   5: '到店',
//   6: '已成单',
//   7: '自定义',
// };

const OPTIONS_ADD_WAY = [
  { value: 0, label: '未知来源' },
  { value: 1, label: '扫描二维码' },
  { value: 2, label: '搜索手机号' },
  { value: 3, label: '名片分享' },
  { value: 4, label: '群聊' },
  { value: 5, label: '手机通讯录' },
  { value: 6, label: '微信联系人' },
  { value: 7, label: '来自微信的添加好友申请' },
  { value: 8, label: '安装第三方应用时自动添加的客服人员' },
  { value: 9, label: '搜索邮箱' },
  { value: 201, label: '内部成员共享' },
  { value: 202, label: '管理员/负责人分配' },
];

const FILTER_ID_REG = {
  pattern: /^(\d+)?$/,
  message: 'ID只包含数字',
};

let filterData = {};

/**
 * 检查是否有某个操作的具体权限
 */
const valid = (str) => {
  const rights = _.get(window, 'pageProps.privileges');
  if (!rights) return true;
  return rights.indexOf(str) !== -1;
};

const getOptionListByMap = (map) => {
  return Object.keys(map).map((key) => {
    const valueIsNumbner = _.isInteger(+key);
    const value = valueIsNumbner ? +key : key;
    return { value, label: map[key] };
  });
};

const getUniId = (obj) => {
  const spliter = '___';
  return [obj.externalUserId, spliter, obj.wxWorkUserId].join('');
};

const QrcodeOverlay = ({ _data }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');
  const size = 128;
  const styleContainer = {
    width: size,
    height: size,
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'center',
    boxShadow: 'rgb(0 0 0 / 5%) 0px 6px 24px 0px, rgb(0 0 0 / 8%) 0px 0px 0px 1px',
  };
  const styleCanvas = {
    width: '100%',
    height: '100%',
  };
  const styleTitle = {
    textAlign: 'center',
    paddingBottom: 8,
  };
  useEffect(() => {
    const opt = { padding: 0 };
    RPCFactory.wechatMaterial
      .getLandingPage(_data.advertiserId, _data.pageId)
      .done((data) => {
        setLoading(false);
        const url = _.get(data, 'previewUrl', '');
        if (!data) {
          setErr('系统繁忙，请稍后再试');
          return;
        }
        if (data && !data.previewUrl) {
          setErr('功能正在升级中，尽请期待');
          return;
        }
        const codeSource = jrQrcode.getQrBase64(url, opt);
        setContent(codeSource);
      })
      .fail(() => {
        setLoading(false);
        setErr('系统繁忙，请稍后再试');
      });
  }, [_data]);

  let code = null;
  if (loading) {
    code = (<Loading />);
  } else if (content) {
    code = (<img src={content} style={styleCanvas} />);
  } else if (err) {
    code = (
      <div style={{ width: '6em', display: 'inline-block' }}>
        {err}
      </div>
    );
  }

  return (
    <div>
      <p style={styleTitle}>微信扫码预览落地页</p>
      <div className="overlay-qrcode__code" style={styleContainer}>
        {code}
      </div>
    </div>
  );
};

// 编辑电话的弹窗
const EditPhoneDialog = (props) => {
  if (props.currentDialogType !== 'phone') return null;
  const data = props.dialogData;
  const phoneReg = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
  const [phone, setPhone] = useState((data.phoneNumbers || []).join(','));
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (typeof props.onDialogCancel !== 'function') return;
    props.onDialogCancel();
  };

  const handleSubmit = () => {
    if (data.phoneNumbers.length < 2) {
      const isValidPhone = phoneReg.test(phone);
      if (phone && !isValidPhone) return window.alert('请输入正确的手机号');
    } else {
      if (phone && phone.split(',').some(p => !phoneReg.test(p))) {
        return window.alert('请确保所有的手机号都是正确的');
      }
    }
    setLoading(true);
    RPCFactory.qwCustomer.updatePhone({
      wxWorkUserId: data.wxWorkUserId,
      externalUserId: data.externalUserId,
      phoneNumberList: phone.split(',').filter(Boolean),
    }).done(() => {
      setTimeout(() => {
        handleCloseDialog();
        if (typeof props.onDialogSubmit !== 'function') return;
        props.onDialogSubmit();
      }, CUSTOMER_DATA_REFRESH_DELAY);
    }).fail((ret, msg) => {
      setLoading(false);
      window.alert(msg);
    });
  };

  return (
    <Dialog
      show
      title="修改手机号"
      type="simple"
      loading={loading}
      style={{ width: 450 }}
      onSubmit={handleSubmit}
      onCancel={handleCloseDialog}
      onClose={handleCloseDialog}
    >
      <div>
        <br />
        <Input
          value={phone}
          onChange={(e, value) => setPhone(value)}
          placeholder="请输入手机号"
        />
      </div>
    </Dialog>
  );
};

const getTagIds = (tagArr) => {
  if (!Array.isArray(tagArr)) return;
  return tagArr.map(t => t.tagId);
};

// 编辑标签的弹窗
const EditTagsDialog = (props) => {
  if (props.currentDialogType !== 'tags') return null;
  const data = props.dialogData;
  const { isBatch } = data;
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState(isBatch ? [] : getTagIds(data.tags));

  const tagMap = useMemo(() => {
    const map = {};
    const fn = (obj) => {
      if (_.isArray(obj.options)) {
        if (obj.options.length < 1) {
          map[obj.value] = {
            groupName: obj.desc,
            groupId: obj.value,
            tagName: '',
            tagId: '',
          };
          return;
        }
        obj.options.forEach((t) => {
          map[t.value] = {
            groupId: obj.value,
            groupName: obj.desc,
            tagId: t.value,
            tagName: t.desc,
          };
        });
      }
    };
    props.optionTags.map(fn);
    return map;
  }, [props.optionTags]);

  const handleCloseDialog = () => {
    if (typeof props.onDialogCancel !== 'function') return;
    props.onDialogCancel();
  };

  const handleTagsChange = (e, value) => {
    setTags(value);
  };

  const handleSubmit = () => {
    // if (tags.length < 1) return alert('请选择标签');
    setLoading(true);
    const id = getUniId(data);
    const ids = isBatch ? props.batch : [id];
    const idCutter = (str) => {
      const cuts = str.split('___');
      return {
        wxWorkUserId: cuts[1],
        externalUserId: cuts[0],
      };
    };
    const tagGetter = (t) => tagMap[t];
    RPCFactory.qwCustomer.updateTags({
      userIdPairs: ids.map(idCutter),
      selectedTagList: tags.map(tagGetter),
    }).done(() => {
      const afterEditTagSuccess = () => {
        handleCloseDialog();
        if (typeof props.onDialogSubmit !== 'function') return;
        props.onDialogSubmit();
      };
      setTimeout(afterEditTagSuccess, CUSTOMER_DATA_REFRESH_DELAY);
    }).fail((_c, msg, _xh, _d) => {
      window.alert(msg);
      setLoading(false);
      if (isBatch && typeof props.onBatchFail === 'function') {
        props.onBatchFail(_d.entities);
      }
    });
  };

  return (
    <Dialog
      show
      title="修改标签"
      type="simple"
      loading={loading}
      style={{ width: 450 }}
      onSubmit={handleSubmit}
      onCancel={handleCloseDialog}
      onClose={handleCloseDialog}
    >
      <div>
        <br />
        <SelectTree
          multiple
          valueType="child"
          value={tags || []}
          data={props.optionTags || []}
          onChange={handleTagsChange}
          showParentNodeLabel={false}
        />
      </div>
    </Dialog>
  );
};

// 客服拉取优化按钮
const PullQwHistoryCustomerBtn = ({ onSuccess }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [show, setShow] = useState(false);

  const qwPatams = (() => {
    const { pageProps } = window;
    const { corpId, wxWorkRole, wxWorkUserId } = pageProps;
    return { corpId, wxWorkRole, wxWorkUserId };
  })();

  const canBeShowed = (() => {
    // 仅企微员工（非管理员）角色能展示历史客户拉取开关
    const { corpId, wxWorkRole, wxWorkUserId } = qwPatams;
    if (!corpId) return false;
    if (!wxWorkUserId) return false;
    return wxWorkRole > 1;
  })();

  const getRemoteState = useCallback((cb) => {
    const successCb = (data) => {
      if (typeof cb === 'function') {
        cb(data);
        return;
      }
      setShow(data.pullExternalUserConfig === 0);
    };
    const { pageProps = {} } = window;
    const { corpId } = pageProps;
    const params = {
      corpId,
      wxWorkUserId: qwPatams.wxWorkUserId,
    };
    if (!params.wxWorkUserId || !params.corpId) {
      setShow(false);
      return;
    }
    RPCFactory.qwCustomer
      .getPullQwHistoryCustomerConfig(params)
      .done(successCb)
      .fail(() => setShow(false));
  }, [qwPatams.wxWorkUserId]);

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setSubmitting(false);
  }

  const handleConfirm = () => {
    setSubmitting(true);
    const successCb = () => {
      handleConfirmClose();
      setShow(false);
      onSuccess && onSuccess();
    };
    const { corpId, wxWorkUserId } = qwPatams;
    const params = { corpId, wxWorkUserId, config: 1 };
    RPCFactory.qwCustomer
      .setPullQwHistoryCustomerConfig(params)
      .done(successCb)
      .fail((ret, msg) => {
        handleConfirmClose();
        window.alert(msg);
      });
  };

  const handleSwitchOpen = () => {
    setShowConfirm(true);
  }

  useEffect(getRemoteState, [getRemoteState]);

  if (!(canBeShowed && show)) return null;

  return (
    <div className="pqhcb">
      <span className='pqhcb-title'>拉取历史企微客户&nbsp;&nbsp;</span>
      <Switch
        style={{ verticalAlign: '-3px', marginRight: '4px', lineHeight: 1 }}
        checked={false}
        onChange={handleSwitchOpen}
      ></Switch>
      <Dialog
        type="normal"
        title="拉取历史企微客户"
        show={showConfirm}
        loading={submitting}
        submitLabel="确认开启"
        cancelLabel="再想想"
        style={{ width: 400, textAlign: 'center' }}
        headerStyle={{ textAlign: 'center' }}
        footerStyle={{ textAlign: 'center' }}
        onClose={handleConfirmClose}
        onCancel={handleConfirmClose}
        onSubmit={handleConfirm}
      >
        <p style={{ fontSize: '14px', color: '#626366' }}>开启后，将拉取并展示历史全部企微客户</p>
        <p style={{ fontSize: '14px', color: '#FA8E00', marginTop: 16 }}>该操作不可逆，请谨慎操作</p>
      </Dialog>
    </div>
  );
};

const List = (props) => {
  const lvRef = useRef();
  const [dialog, setDialog] = useState(null);
  const [dialogData, setDialogData] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  // 标签筛选下拉菜单
  const [optionsTag, setOptionsTag] = useState([]);
  const [workerList, setWorkerList] = useState([]);
  const [codeOptions, setCodeOptions] = useState([]); // 渠道活码

  const [downloading, setDownloading] = useState(false);

  // 默认展示的筛选条件，值为 filterControls 中的 name
  const defaultFilterKeys = [
    'addTime',
    'name',
    valid('WX_WORK_CORP_TAGS_VIEW') ? 'tags' : null,
    'addWay',
    'followStatus',
    'deleteStatus',
  ].filter(Boolean);

  // 展示的列
  const showColumns = [
    'name',
    'markName',
    'gender',
    'source',
    'customerStatus',
    'followStatus',
    valid('WX_WORK_CORP_TAGS_VIEW') ? 'tags' : null,
    'phone',
    'isRepeat',
    'advertise',
    'campaign',
    'page',
    'link',
    'advertiserId',
    'configName',
    'owner',
    'matchedLeadsOwnerName',
    'addTime',
  ].filter(Boolean);

  const initQuery = {
    addTime: {
      start_time: moment().subtract(29, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
  };

  // 登录账号是否是服务商
  // 服务商不能在页面修改手机号和标签
  const isServiceProvider = window.pageProps.operatorRole === 'OPERATOR_ROLE_LEADS_AGENCY';

  const getList = (params) => new Promise((res, rej) => {
    RPCFactory.qwCustomer.getList(params)
      .done((data) => {
        const arr = data.entities.map((item) => {
          const customerStatusMap = {
            0: '正常',
            1: '客服删除',
            2: '客户删除',
          };
          let campaign = item.campaignName;
          let advertise = item.adGroupName;
          let page = item.pageName;
          if (item.campaignId) campaign += `(${item.campaignId})`;
          if (item.adGroupId) advertise += `(${item.adGroupId})`;
          if (item.pageId) page += `(${item.pageId})`;
          const _data = { ...item };
          if (!_.isArray(_data.tags)) {
            _data.tags = [];
          } else {
            _data.tags = _data.tags.filter(t => t.tagName);
          }
          return {
            _data,
            _id: getUniId(item),
            campaign,
            advertise,
            page,
            name: item.name,
            markName: item.remark,
            source: CUSTOMER_ADD_WAY_MAP[item.addWay],
            customerStatus: customerStatusMap[item.deleteStatus],
            followStatus: item.followStatusDesc || Tags.qwFollowStatus[item.followStatus],
            gender: GENDER_MAP[item.gender],
            tags: item.tags || [],
            phone: item.phoneNumbers,
            isRepeat: REPEAT_MAP[item.repeated],
            owner: item.wxWorkUserName,
            addTime: item.addExternalUserIdTime,
            link: item.pageUrl,
            advertiserId: item.advertiserId,
            configName: item.configName,
          };
        });
        res({
          list: arr,
          page_info: {
            total_number: _.get(data, 'page_info.total_number') || 0,
          },
        });
      })
      .fail((ret, msg) => rej(msg));
  });

  const reloadList = () => {
    if (typeof lvRef.current.loadList !== 'function') return;
    lvRef.current.loadList();
    lvRef.current.setSelectKeys([]);
    lvRef.current.setBatchShow(false);
  };

  const handleOpenDialog = (type, data) => {
    setDialog(type);
    setDialogData(data);
  };

  // ----------------------- 列渲染方法 -----------------------
  // 手机号
  const renderPhone = (type, name, value, data) => {
    const { _data } = data;
    let phone = value;
    const phones = _.flatten([_data.phoneNumbers]);
    if (phones.length < 2) {
      phone = phones.pop();
    } else {
      phone = phones.map((p, i) => (<div key={i}>{p}</div>));
    }

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>{phone}</div>
        {
          valid('WX_WORK_CUSTOMER_EDIT_PHONE')
          && _data.deleteStatus !== 1
          && !isServiceProvider
          && (
            <i
              className="icon-pen icon-in-cell"
              style={{ marginLeft: 6 }}
              onClick={() => handleOpenDialog('phone', _data)}
            />
          )
        }
      </div>
    );
  };

  // 标签
  const renderTags = (type, name, value, data) => {
    const { _data } = data;
    const tags = _data.tags.map((item) => item.tagName).join(', ');
    return (
      <span>
        <span className="line-max-width mw-15em" title={tags}>
          {tags}
        </span>
        {
          valid('WX_WORK_CUSTOMER_EDIT_TAGS')
          && _data.deleteStatus !== 1
          && !isServiceProvider
          && (
            <i
              className="icon-pen icon-in-cell"
              style={{ marginLeft: 6 }}
              onClick={() => handleOpenDialog('tags', _data)}
            />
          )
        }
      </span>
    );
  };

  // 推广链接
  const renderLink = (type, name, value, data) => {
    const { _data } = data;
    const style = {
      maxWidth: '15em',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      verticalAlign: 'bottom',
    };
    const props = {
      style,
      href: value,
      title: value,
      target: '_blank',
    };
    if (
      Number(_data.advertiserId) > 0
      && Number(_data.pageId) > 0
      && /https?:\/\/mp\.weixin\.qq\.com/.test(_data.pageUrl)
    ) {
      const showQrcode = (e) => {
        e.preventDefault();
      };
      const overlay = (
        <PopOver>
          <QrcodeOverlay _data={_data} />
        </PopOver>
      );
      return (
        <a onClick={showQrcode} style={style}>
          <OverlayTrigger
            placement="top"
            trigger="click"
            overlay={overlay}
          >
            点击查看预览二维码
          </OverlayTrigger>
        </a>
      );
    }
    if (!_data.pageUrl) return '-';
    return (<a {...props}>{value}</a>);
  };

  const renderLimitedLength = (type, name, value) => {
    if (!value) return '-';
    const style = {
      maxWidth: '15em',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      display: 'inline-block',
      verticalAlign: 'bottom',
    };
    return (
      <span style={style} title={value}>
        {value}
      </span>
    );
  };

  const renderOwner = (type, name, value, data) => {
    const style = {
      maxWidth: 300,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    return <ww-open-data style={style} type="userName" openid={data.owner} />;
  };

  const renderFormOwner = (type, name, value, data) => {
    const { _data } = data;
    return _data.matchedLeadsOwnerName || '-';
  }

  // 操作
  const renderOptions = (/* type, name, value, _data */) => {
    return '-';
  };
  // --------------------------------------------------------

  // 列渲染方法 map
  // 注意：使用的时候需要注入 name: [key] 属性
  const columnMap = {
    name: { title: '昵称' },
    markName: { title: '备注名' },
    source: { title: '客户来源' },
    customerStatus: { title: '客户状态' },
    advertise: { title: '广告', render: renderLimitedLength },
    campaign: { title: '推广计划', render: renderLimitedLength },
    page: { title: '落地页', render: renderLimitedLength },
    link: { title: '推广链接', render: renderLink },
    advertiserId: { title: '推广账号ID' },
    configName: { title: '渠道活码名称' },
    followStatus: { title: '跟进状态' },
    gender: { title: '性别' },
    tags: { title: '标签', render: renderTags },
    phone: { title: '手机号', render: renderPhone },
    isRepeat: { title: '重复标记' },
    owner: { title: '归属人', render: renderOwner },
    matchedLeadsOwnerName: { title: '表单归属人', render: renderFormOwner },
    addTime: { title: '添加时间' },
    options: {
      title: '操作',
      // fixedable: true,
      // fixedAlign: 'right',
      render: renderOptions,
    },
  };

  // const SelectOwnerComponent = () => {};
  const filterControls = [
    {
      name: 'addTime',
      title: '添加时间',
      type: 'date-picker',
      clearable: false,
      config: {
        type: 'range',
        longestRange: '365',
        useShortcut: true,
        shortcuts: DATE_SHORTCUTS,
      },
    },
    {
      name: 'name',
      title: '姓名',
      type: 'search',
    },
    {
      name: 'tags',
      title: '标签',
      type: 'select-tree',
      config: {
        data: optionsTag,
        multiple: true,
        showParentNodeLabel: false,
        valueType: 'child',
        dropStyle: { width: 300 },
      },
    },
    {
      name: 'addWay',
      title: '客户来源',
      type: 'select',
      config: { data: OPTIONS_ADD_WAY },
    },
    {
      name: 'followStatus',
      title: '跟进状态',
      type: 'select',
      config: { data: getOptionListByMap(Tags.qwFollowStatus) },
    },
    {
      name: 'deleteStatus',
      title: '客户状态',
      type: 'select',
      config: { data: getOptionListByMap(CUSTOMER_DELETE_STATUS) },
    },
    {
      name: 'gender',
      title: '性别',
      type: 'select',
      config: { data: getOptionListByMap(GENDER_MAP) },
    },
    {
      name: 'owner',
      title: '归属人',
      type: 'select',
      config: {
        multiple: true,
        data: workerList,
        SelectionItemComponent,
        ValueAreaComponent,
      },
    },
    {
      name: 'repeated',
      title: '是否重复标记',
      type: 'select',
      config: { data: getOptionListByMap(REPEAT_MAP) },
    },
    {
      name: 'pageId',
      title: '落地页ID',
      type: 'search',
      rules: [FILTER_ID_REG],
    },
    {
      name: 'advertiserId',
      title: '推广账号ID',
      type: 'search',
      rules: [FILTER_ID_REG],
    },
    {
      name: 'adGroupId',
      title: '广告ID',
      type: 'search',
      rules: [FILTER_ID_REG],
    },
    {
      name: 'adGroupName',
      title: '广告名称',
      type: 'search',
    },
    {
      name: 'campaignName',
      title: '推广计划名称',
      type: 'search',
    },
    {
      name: 'campaignId',
      title: '推广计划ID',
      type: 'search',
      rules: [FILTER_ID_REG],
    },
    {
      name: 'configNameList',
      title: '渠道活码名称',
      type: 'select',
      config: { multiple: true, data: codeOptions },
    },
  ];

  const handleCloseDialog = () => {
    setDialogData({});
    setDialog(null);
  };

  const handleBatchEditTagFail = (arr = []) => {
    const failed = arr.map(getUniId);
    lvRef.current.setSelectKeys(failed);
    reloadList();
  };

  // 选中的行变化时
  const handleRowSelect = (e, value) => {
    setSelectedRows(value);
  };

  const handleDownload = () => {
    setDownloading(true);
    const params = { ...filterData };
    delete params.pageSize;
    delete params.pageIndex;

    let url = `/api/v1/wx_work_external_user/down_list`;
    url += `?accountId=${window.pageProps.uid}`;
    url += `&corpId=${window.pageProps.corpId}`;
    url += `&csrfToken=${window.pageProps.token}`;

    let filename = '';

    fetch(url, {
      method: 'post',
      body: JSON.stringify(params),
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => {
        setDownloading(false);
        filename = res.headers.get('content-disposition');
        const type = res.headers.get('content-type');
        if (type === 'application/x-download') {
          return res.blob();
        }
        return res.json();

      })
      .then((data) => {
        if (data instanceof Blob) {
          const fnr = filename.match(/([^=]+\.csv)$/);
          if (fnr) filename = fnr[0];
          const _url = window.URL.createObjectURL(data);
          const a = document.createElement('a');
          a.href = _url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else if (data.code !== 0) {
          window.alert(data.msg);
        }
      })
      .catch(() => {
        setDownloading(false);
      });
  };

  const customFilterConfigure = useCustomColumn({
    defaultFilterKeys,
    controls: filterControls,
    storageKey: 'ams:user_profile:advertiser_custom_filters_/leads/qw/customer/customerList',
  });

  const lvOptions = () => ({
    fetchConfig: {
      action: getList,
      $onRequest(params) {
        const obj = { ...params };
        delete obj.page_size;
        delete obj.page;
        delete obj.addTime;
        delete obj.tags;
        delete obj.owner;
        delete obj.configNameList;
        obj.pageIndex = params.page;
        obj.pageSize = params.page_size;
        obj.tagList = params.tags;
        obj.wxWorkUserIdList = params.owner;
        if (_.get(params, 'addTime.start_time') && _.get(params, 'addTime.end_time')) {
          obj.addStartTime = moment(params.addTime.start_time).format('YYYY-MM-DD');
          obj.addEndTime = moment(params.addTime.end_time).format('YYYY-MM-DD');
        }
        ['campaignId', 'adGroupId', 'pageId', 'advertiserId'].forEach((key) => {
          if (!obj[key]) return;
          obj[key] = Number(obj[key]);
        });
        filterData = obj;
        if (Array.isArray(params.configNameList)) {
          obj.configNameList = params.configNameList.map((str) => str.split('-').pop());
        }
        return obj;
      },
      $onResponse(data) {
        return data;
      },
      $onError: window.alert,
    },
    toolbarConfig: {
      left: (
        <div className="toolbar-left">
          <h4>客户信息</h4>
        </div>
      ),
      right: (
        <div className="toolbar-right-group">
          <PullQwHistoryCustomerBtn onSuccess={reloadList} />
          <Button onClick={handleDownload} className="borderless" loading={downloading}>
            <i className="icon icon-download"></i>
            <span className="spaui-text">下载客户数据</span>
          </Button>
        </div>
      ),
    },
    filterConfig: {
      resetable: false,
      controls: filterControls,
      customConfigure: customFilterConfigure,
      defaultValuesByKey: initQuery,
    },
    batchConfig: {
      left: (
        <div className="toolbar-right-group">
          {
            !isServiceProvider && (
              <Button
                className="borderless"
                onClick={() => handleOpenDialog('tags', { isBatch: true })}
              >
                <i className="icon icon-batch" />
                批量修改标签
              </Button>
            )
          }
        </div>
      ),
    },
    tableConfig: {
      defaultPageSize: 10,
      select: valid('WX_WORK_CUSTOMER_EDIT_TAGS') && !isServiceProvider ? 'multiple' : null,
      columns: showColumns.map(key => {
        return { ...columnMap[key], name: key };
      }),
      rowKey: '_id',
      onOptionalChange: handleRowSelect,
      optionalConfig: {
        max: 20,  // 数值会被 canOptional 顶掉不起作用，但是可以让全选框消失
        canOptional: ({ _id, _data }) => {
          const max = 20;
          if (_data.deleteStatus === 1) return false;
          if (selectedRows.indexOf(_id) !== -1) return true;
          return selectedRows.length < max;
        },
      },
    },
  });

  useEffect(() => {
    // 获取标签的映射关系
    RPCFactory.qwCustomer.getAllTag().done((data) => {
      const dealGroup = (group) => {
        const options = group.tag.map((t) => ({
          value: t.id,
          desc: t.name,
        }));
        return {
          options,
          value: group.groupId,
          desc: group.groupName,
        };
      };
      setOptionsTag(data.map(dealGroup));
      console.log(data.map(dealGroup))
    });

    // 获取所有的添加人(归属人)
    RPCFactory.qwCustomer.getWorkers().done((data) => {
      const arr = data.entities.map(item => ({
        value: item.wxWorkUserId,
        label: item.name,
      }));
      setWorkerList(arr);
    });

    // 获取渠道活码
    const codes = [];
    const fetchAllByLoop = false;
    let codeTotal = -1;
    const getCodes = (page = 1) => {
      RPCFactory.qwDrainage.getList({ pageSize: 50, pageIndex: page })
        .done((res) => {
          if (codeTotal < 0) codeTotal = _.get(res, 'page_info.total_number') || 0;
          (res.entities || []).forEach((item) => codes.push({
            label: item.name,
            value: `${item.id}-${item.name}`,
          }));
          if (fetchAllByLoop && codes.length < codeTotal) getCodes(page + 1);
          else setCodeOptions(codes);
        });
    };
    // 渠道活码的筛选不确定是input还是select，是input就不需要执行
    getCodes();
  }, []);

  return (
    <main id="main" className="main">
      <CorpSelector {...props} onChange={reloadList} />
      <div className="page-pool">
        <div className="card borderd" style={{ paddingTop: 0 }}>
          <div className="datalist">
            <ListView
              className="lv"
              ref={lvRef}
              options={lvOptions}
            // payloads={this.payloads} // 不知道干啥用的
            // customFunctions={this.customFunctions} // 一样不知道干啥的
            />
          </div>
        </div>
      </div>
      <EditPhoneDialog
        currentDialogType={dialog}
        dialogData={dialogData}
        onDialogCancel={handleCloseDialog}
        onDialogSubmit={reloadList}
      />
      <EditTagsDialog
        currentDialogType={dialog}
        dialogData={dialogData}
        onDialogCancel={handleCloseDialog}
        onDialogSubmit={reloadList}
        optionTags={optionsTag}
        batch={selectedRows}
        onBatchFail={handleBatchEditTagFail}
      />
    </main>
  );
};

export default List;
